module.exports = __webpack_public_path__ + "static/img/icon_bg2_vi.e20ee71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_bg2_vi.png
// module id = 2pU7
// module chunks = 0